import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import React from 'react';

export interface ISliderArrowProps {
  direction: 'left' | 'right';
  onClick?: () => void;
}

export const SliderArrow = ({ direction, onClick }: ISliderArrowProps) => (
  <div>
    {direction === 'left' ? (
      <KeyboardArrowLeft className="slick-prev" onClick={onClick} />
    ) : (
      <KeyboardArrowRight className="slick-next" onClick={onClick} />
    )}
  </div>
);
